// extracted by mini-css-extract-plugin
module.exports = {"title":"ApplicationModal_title__2jvss","content":"ApplicationModal_content__zFZsu","main":"ApplicationModal_main__mGy_N","sidebar":"ApplicationModal_sidebar__3VKz1"};